import HorizontalScroll from './HorizontalScroll';

export default HorizontalScroll;
